import React, { Component } from 'react';
import { Link } from 'react-router';
import isEqual from 'lodash/isEqual';
import anchorme from 'anchorme';
import moment from 'moment';
import { v4 } from 'node-uuid';
import { getDetailedCost } from 'pap/utils';
import { isCollaborator } from 'project/utils';
import CostBreakdown from 'pap/components/common/cost_breakdown';
import ContractPreviewModal from 'common/components/modal/contract_preview';
import Slider from 'pap/components/common/slider_selector';
import classnames from 'classnames';

export const ANCHORME_OPTIONS = {
  truncate: 40,
  attributes:[
    {
      name:"target",
      value:"_blank"
    }
  ]
};

class SingleLineAnswer extends React.Component {

  render() {
    const { input, name, stepTitle, stepDescription, stepHelp, stepNumber, stepCount} = this.props;

    return (
      <div className="pap-form-field-answer" key={name}>
        <p>{ this.props.value }</p>
      </div>
    );
  }
}

const URLAnswer = (props) => {
  if (!props.value || props.value.trim() === 0) {
    return null;
  }

  var value = anchorme(props.value, ANCHORME_OPTIONS);
  return <div className="pap-form-field-answer" key={props.name}>
    <p dangerouslySetInnerHTML={{__html: value}}/>
  </div>
}

const TextAnswer = (props) => {
  return (
    <div className="pap-form-field-answer" key={props.name}>
    <p>
    {props.value && props.value.split('\n').map((item, key) => {
      var textWithAnchors = "" + anchorme(item, ANCHORME_OPTIONS) + "<br/>";
      return <span key={key} dangerouslySetInnerHTML={{__html: textWithAnchors}}/>;
      })}
    </p>
    </div>
  );
}

const HTMLTextAnswer = ({ name, value }) => {
  return (
    <div className="pap-form-field-answer" key={name} dangerouslySetInnerHTML={{ __html: value }} />
  );
}

const SelectAnswer = ({ fieldDefinition, value }) => {
  if (!value) {
    return null;
  }

  const correspondingOption = fieldDefinition.options.find(o => o.field === value);

  return (
    <div className="pap-form-field-answer" key={fieldDefinition.name}>
      <p>{ correspondingOption? correspondingOption.label : null }</p>
    </div>
  );
}

const RadioAnswer = ({ value, fieldDefinition }) => {
  const correspondingOption = fieldDefinition.options.find(o => o.field === value);

  return (
    <div className="pap-form-field-answer" key={fieldDefinition.name}>
      <p>{ correspondingOption? correspondingOption.label : null }</p>
    </div>
  );
}

const ItemListAnswer = (props) => {
  if (!props.value) {
    return null;
  }

  return (
    <ul className="pap-form-field-answer item-list-answers">
      {props.value.map((item, i) => (
        <li key={i}>
          {item.url?
          <strong dangerouslySetInnerHTML={{__html: anchorme(item.url, ANCHORME_OPTIONS)}}/>:
          <strong>{ item.title }</strong>}

          <p>{ item.description }</p>
        </li>)
      )}
    </ul>)
}

const FeatureSelectAnswer = (props) => {
  if (!props.value) {
    return null;
  }

  return (
    <div className="pap-form-field-answer" key={props.name}>
      <ul className="features-selector">
        {props.value.map((value, i) => {
          return (
            <li className="tile" key={i}>
              <div className="row">
                <div className="feature-icon columns small-8 medium-6">
                  <i className={ value.icon }/>
                  <h5 className="show-for-small-only">{ value.label }</h5>
                </div>
                <div className="feature-description columns small-8 medium-10">
                  <h5 className="hide-for-small-only">{ value.label }</h5>
                  <p>{ value.description }</p>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const MultiGridSelectAnswer = ({ value, fieldDefinition }) => {
  if (!value || value.length === 0) {
    return null;
  }

  return (
    <div className="pap-form-field-answer grid-selector grid-selector-answer" key={v4()}>
      <ul className="row small-up-2 medium-up-3">
        {value.map((value) => {
          const correspondingOption = fieldDefinition.options.find(o => o.field === value);

          if (!correspondingOption) {
            return null;
          }

          const isText = correspondingOption.icon == 'text';

          return (
            <li key={v4()} className="column column-block">
              <div className={classnames("text-center tile read-only", {"text-only": isText})}>
                {isText?
                <h3 dangerouslySetInnerHTML={{ __html: correspondingOption.label }}></h3>:
                <div>
                  <i className={correspondingOption.icon}/>
                  <h4 dangerouslySetInnerHTML={{ __html: correspondingOption.label }}></h4>
                </div>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const MultiSelectAnswer = ({ value, fieldDefinition }) => {
  if (!value || value.length === 0) {
    return null;
  }

  return (
    <div className="pap-form-field-answer multi-selector multi-selector-answer" key={v4()}>
      {value.map((value, i) => {
        const correspondingOption = fieldDefinition.options.find(o => o.field === value);

        if (!correspondingOption) {
          return null;
        }

        return (
          <span key={i}>
          { correspondingOption.label }{ i < value.length - 1? ', ' : '' }
          </span>
        );
      })}
    </div>
  );
}

const BinarySelectorAnswer = ({ value, name }) => {
  return (
    <div className="pap-form-field-answer" key={name}>
      { (value || []).map(v => v.label).join(', ') }
    </div>
  );
}

const ColorAnswer = (props) => {
  if (!props.value) {
    return null;
  }
  return <div className="pap-form-field-answer color-choices" key={props.name}>
            <div className="row small-up-2 medium-up-3">
              {props.value.map((value) => {
                const group = props.fieldDefinition.options.find(o => isEqual(o.colors, value));
                return <div className="column column-block text-center" key={v4()}>
                  <div className="tile read-only">
                    { value.map((color) => { return <div className="color-block" key={v4()} style={{backgroundColor: `#${color}`}}/>}) }
                    <div className="clearfix"/>
                    <h4>{group.name}</h4>
                  </div>
                </div>
              })}
            </div>
          </div>
}

const CostAnswer = ({projectData, name, awardValue1to1, packageName, user}) => {
  if (!projectData) {
    return null
  }

  const detailedCost = getDetailedCost(
    projectData.features, projectData.award_rules, {}, awardValue1to1, projectData.billables, user,
    projectData.package_tips
  )

  return (
    <div className="pap-form-field-answer" key={name}>
      <CostBreakdown detailedCost={detailedCost} packageName={packageName}/>
    </div>)
}

class ContractAnswer extends Component {
  constructor(props) {
    super(props);

    this.state = { showingPreview: false };

    this.togglePreview = this.togglePreview.bind(this);
  }

  togglePreview() {
    this.setState({ showingPreview: !this.state.showingPreview });
  }

  render() {
    const { value, name } = this.props;
    const contractData = value.contract;

    return (
      <div className="pap-form-field-answer" key={name}>
        <p>
          {contractData.isCustom?
          <a href={contractData['custom_contract'].file} target="_blank">
            {contractData['custom_contract'].description}
          </a>:
          <a onClick={this.togglePreview}>crowdspring</a>}
        </p>
        <ContractPreviewModal showing={this.state.showingPreview} onClose={this.togglePreview}
            url={`/api/v1/projects/${value.projectId}/ica_preview/`} />
      </div>)
  }
}

const FilesAnswer = ({ value, name, projectData, userData }) => {
  const attachments = value['file_upload'];
  const user = userData || {};
  const project = projectData || {};
  /* clients and collaborators and admins can see the full list */
  const canSeeList = (
    user.id &&
    project.id &&
    (user.id === project.client || isCollaborator(project) || user.is_staff)
  );

  /* only show link to ZIP file if present and project is not draft */
  const canSeeZip = project.attachments_zip && project.status !== "draft";
  const zipCreatedAt = (
    project.attachments_zip_created_at?
    moment(project.attachments_zip_created_at).format('MM/DD/YYYY h:mma') : ''
  );

  return (
    <div className="pap-form-field-answer pap-files-answer" key={name}>
      { canSeeList &&
      <div>
        { attachments.map((att, i) => (
          <p key={i}>
            <a href={att.file} target="_blank">{att.description}</a>
          </p>
        )) }
      </div> }

      { attachments.length === 0 && <p>No Files Added</p> }

      { canSeeZip &&
      <div>
        <Link to={project.attachments_zip} target="_blank">
          <i className="fa fa-download"/> Download all project files
        </Link>
        { zipCreatedAt &&
        <div className="zip-created-at">
          Last updated { zipCreatedAt }
        </div> }
      </div> }
    </div>)
}

const SliderSelectorAnswer = ({ fieldDefinition, value }) => {
  return (
    <Slider options={fieldDefinition.options} value={value || []}  />
  );
}


export const PAP_ANSWER_RENDERER_COMPONENTS = {
  "text": SingleLineAnswer,
  "url": URLAnswer,
  "textarea": TextAnswer,
  "textarea_html": HTMLTextAnswer,
  "select": SelectAnswer,
  "radio": RadioAnswer,
  "item-list": ItemListAnswer,
  "multi-grid-select": MultiGridSelectAnswer,
  "multi-select": MultiSelectAnswer,
  "color-selector": ColorAnswer,
  "feature-select": FeatureSelectAnswer,
  "binary-select": BinarySelectorAnswer,
  "cost": CostAnswer,
  "contract": ContractAnswer,
  "files": FilesAnswer,
  "slider-select": SliderSelectorAnswer,
};



// WEBPACK FOOTER //
// ./pap/components/common/answer_renderers/index.jsx